import { render, staticRenderFns } from "./resetPwd.vue?vue&type=template&id=0b33df44&scoped=true"
import script from "./resetPwd.vue?vue&type=script&lang=ts"
export * from "./resetPwd.vue?vue&type=script&lang=ts"
import style0 from "./resetPwd.vue?vue&type=style&index=0&id=0b33df44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b33df44",
  null
  
)

export default component.exports